import urls from "global/constants/UrlConstants";
import { SignRequest, SortingConfig } from "models/interfaces";
import { getCallParams, makeCall } from "utils/service";

export const fetchFolderData = async (
  pageNumber: number,
  parentId: number,
  sortConfig: SortingConfig[]
) => {
  const url = `${urls.GET_FOLDER_DATA}/${pageNumber}/parent/${parentId}`;
  try {
    const callParams = await getCallParams("POST", sortConfig);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
export const fetchFolderDataCount = async (parentId: number) => {
  const url = `${urls.GET_FOLDER_DATA_COUNT}/count/parent/${parentId}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const moveFolder = async (
  folderId: number,
  destinationFolder: number
) => {
  const url = `${urls.MOVE_FOLDER}/${folderId}/${destinationFolder}`;
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const createNewFolder = async (
  fromRequest: boolean,
  signRequest: any
) => {
  const url = `${urls.CREATE_NEW_FOLDER}/${fromRequest}`;
  try {
    const callParams = await getCallParams("POST", signRequest);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const renameFolder = async (folderId: any, folderName: string) => {
  const url = `${urls.RENAME_FOLDER}/${folderId}/${folderName}`;
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteTemplate = async (id: number) => {
  const url = `${urls.DELETE_TEMPLATE}/${id}`;
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteAnywayFolder = async (id: number) => {
  const url = `${urls.DELETE_ANYWAY_TEMPLATE}/${id}`;
  try {
    const callParams = await getCallParams("DELETE");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchFolderTree = async () => {
  const url = `${urls.GET_ALL_FOLDERS}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addTemplate = async (template: SignRequest) => {
  const url = `${urls.SAVE_TEMPLATE}/false`;
  try {
    const callParams = await getCallParams("POST", template);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const updateTemplate = async (
  template: SignRequest,
  isRequest: boolean
) => {
  const url = `${urls.UPDATE_TEMPLATE}`;
  try {
    const callParams = await getCallParams("POST", template);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const searchTemplatesAndFolders = async (
  searchText: string,
  signal?: AbortSignal
) => {
  const url = `${urls.TEMPLATE_FOLDER_SEARCH}`;
  const sortConfig: SortingConfig[] = [
    { entity: "template", order: "DESC", field: "createdOn" },
  ];
  const body = {
    searchText: searchText ?? "",
    entitySorters: sortConfig,
  };
  const callParams = await getCallParams("POST", body, signal);
  return await makeCall(url, callParams);
};
